import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { useAuth, AuthContext } from '~/contexts';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AppWrapper } from '~/views/organisms/wrapper-app/wrapper.app';
import { ROUTES } from './routes';
import { PageNotFound } from '~/pages/page.notfound';
import { PageHome } from '~/pages/page.home';
import { PagePayment } from '~/pages/page.payment';
import { PageSupport } from '~/pages/page.support';
import { PageAccount } from '~/pages/page.account';

const router = createBrowserRouter([
    {
        path: ROUTES.MAIN.path,
        element: <AppWrapper />,
        children: [
            {
                path: ROUTES.MAIN.path,
                element: <PageHome />,
            },
        ],
    },
    {
        path: ROUTES.PAYMENT.path,
        element: <AppWrapper />,
        children: [
            {
                path: ROUTES.PAYMENT.path,
                element: <PagePayment />,
            },
        ],
    },
    {
        path: ROUTES.SUPPORT.path,
        element: <AppWrapper />,
        children: [
            {
                path: ROUTES.SUPPORT.path,
                element: <PageSupport />,
            },
        ],
    },
    {
        path: ROUTES.PERSONAL_INFO.path,
        element: <AppWrapper />,
        children: [
            {
                path: ROUTES.PERSONAL_INFO.path,
                element: <PageAccount />,
            },
        ],
    },
    {
        path: ROUTES.ACCOUNT_PAYMENTS.path,
        element: <AppWrapper />,
        children: [
            {
                path: ROUTES.ACCOUNT_PAYMENTS.path,
                element: <PageAccount />,
            },
        ],
    },
    {
        path: ROUTES.PURCHASE_HISTORY.path,
        element: <AppWrapper />,
        children: [
            {
                path: ROUTES.PURCHASE_HISTORY.path,
                element: <PageAccount />,
            },
        ],
    },
    {
        path: ROUTES.MESSAGES.path,
        element: <AppWrapper />,
        children: [
            {
                path: ROUTES.MESSAGES.path,
                element: <PageSupport />,
            },
        ],
    },
    {
        path: '*',
        element: <AppWrapper />,
        children: [
            {
                path: '*',
                element: <PageNotFound />,
            },
        ],
    },
]);

export const AppRouter: FC = observer(() => {
    const authCtx = useAuth();

    return (
        <AuthContext.Provider value={authCtx}>
            <RouterProvider router={router} fallbackElement />
        </AuthContext.Provider>
    );
});
